export default __webpack_public_path__ + "static/media/gorro-cocinero.f0812d27.png";